import 'parsleyjs';

$(function() {
    $('.parsley-form').each(function () {
      console.log(this);
        $(this).parsley();
    });
});
